module.exports = __webpack_public_path__ + "static/media/85x11no1.66aa6b62.jpg";